import { TrunkService } from '@verification/services/TrunkService';
import { snakeStore } from '@app/plugins/vuex-async-pagginate';

export const table = snakeStore(
  {
    actions: {
      getData: (_, params) => TrunkService.getList(params)
    }
  },
  true
);
